import { Link } from 'react-router-dom';
import {
  ArrowRight, Briefcase, Check, Video,
} from 'lucide-react';

export const AudienceSection = () => (
  <section className="border-y border-border/50 bg-secondary/20">
    <div className="max-w-6xl mx-auto px-6 py-12">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest text-center mb-6">
        Öffentlicher MVP-Fokus
      </p>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-card rounded-2xl border-2 border-primary/30 shadow-sm p-6 hover:shadow-lg transition-all relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/70 to-primary rounded-t-2xl" />
          <div className="flex items-start gap-4 mt-1">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900 text-base">Ambulante Praxis</h3>
              <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                Dokumentation, Termine, Teletherapie, Portal, Rechnungen und Nachrichten -
                gebaut für den bezahlten Praxis-MVP.
              </p>
              <div className="mt-3 grid grid-cols-2 gap-1.5">
                {['Patientenakte', 'GNCP-Werkbank', 'Teletherapie', 'Portal & Rechnungen'].map(f => (
                  <div key={f} className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                    <Check className="w-3 h-3 text-primary shrink-0" />
                    {f}
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <Link to="/praxis" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary/80 transition-colors">
                  Zur Praxis-Seite
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-2xl border-2 border-gray-200 shadow-sm p-6 hover:shadow-lg hover:border-blue-200 transition-all">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center shrink-0">
              <Video className="w-6 h-6 text-blue-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900 text-base">Dokumentationsassistent</h3>
              <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                Icarus D&D zeichnet Gespräche auf, strukturiert Inhalte und bereitet Entwürfe vor.
                Die fachliche Freigabe bleibt immer sichtbar beim Menschen.
              </p>
              <div className="mt-3 grid grid-cols-2 gap-1.5">
                {['Transkript', 'Doku-Entwurf', 'Quellenstellen', 'Manuelle Freigabe'].map(f => (
                  <div key={f} className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                    <Check className="w-3 h-3 text-blue-500 shrink-0" />
                    {f}
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors">
                  Demo starten
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
